import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { updateFormData, setListing, updateListing } from '../actions';
import { populateListingFromFormData } from '../helpers';

import DiscountModal from '../components/DiscountModal';
import ListingDiscountComponent from '../components/ListingDiscountComponent';

const mapStateToProps = state => ({
  listing: state.Listing,
  discounts: state.Listing.discounts
});

export const submitDiscount = (discount, formValues, props, closeDiscountFn) => {
  if (discount._id) {
    let discountIndex = formValues.discounts.findIndex(d => d._id === discount._id);
    if (discountIndex > -1) formValues.discounts.splice(discountIndex, 1, discount);
  } else {
    discount._id = `d${discount.name}i${formValues.discounts.length + 1}`;
    formValues.discounts.push(discount);
  }
  props.dispatch(updateFormData(formValues));
  closeDiscountFn();
}

export const removeDiscount = (discount, values, props) => {
  values.discounts = values.discounts.filter(d => d._id !== discount._id);
  props.dispatch(updateFormData(values));
}

class ListingFormDiscounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      discountModalOpen: false,
      editingDiscount: null,
    }
    const workflow = this.props.workflow ? this.props.workflow : 'forms';
    this.nextPage = `/${this.props.parent}/listing/${workflow}/calendars`;
  }

  openDiscountModal = (discount) => {
    if (!discount)
      discount = null;
    this.setState({ discountModalOpen: true, editingDiscount: discount })
  }
  closeDiscountModal = () => { this.setState({ discountModalOpen: false, editingDiscount: null }) }

  onSubmit = (values, { setSubmitting }) => {
    this.setState({ isSubmitting: true });
    let { dispatch, history } = this.props;
    let nextPage = this.nextPage;
    setTimeout(() => {
      let defaultObj = { name: '', code: '' };
      values.discounts = values.discounts.filter((a) => {
        return a.name !== defaultObj.name && a.code !== defaultObj.code;
      });

      dispatch(updateFormData(values));
      history.push(nextPage);
      setSubmitting(false);
    }, 1000);
  }

  exit = (values, { setSubmitting }) => {
    this.setState({ isSubmitting: true });
    let { dispatch, history } = this.props;
    let defaultObj = { name: '', code: '' };
    values.discounts = values.discounts.filter((a) => {
      return a.name !== defaultObj.name && a.code !== defaultObj.code;
    });
    let updatedData = populateListingFromFormData(values);
    setTimeout(() => {
      dispatch(setListing(updatedData));
      dispatch(updateListing());
      history.push(`/${this.props.parent}/manage-listings?view=ma`);
      setSubmitting(false);
    }, 1000)
  }

  goBack = () => {
    this.props.history.goBack();
  }

  render() {
    let { discountModalOpen, editingDiscount } = this.state;
    let initValues = this.props.listing.formData;
    const submitText = this.props.exit ? 'Save' : 'Next';

    return (<div>
      <Formik onSubmit={this.props.exit ? this.exit : this.onSubmit} initialValues={initValues} enableReinitialize={true}>
        {({ values, errors, touched }) => {
          return (
            <Form>
              <div>
                <section className="discounts-container">
                  <ListingDiscountComponent
                    values={values}
                    onDiscountRemove={(discount, values) => removeDiscount(discount, values, this.props)}
                    onDiscountEdit={this.openDiscountModal}
                    showExpired={true} />
                </section>
              </div>
              <div className="button-row row">
                <div className="col-6">
                  <label className="float-left" onClick={this.goBack}>Back</label>
                </div>
                <div className="col-6">
                  {this.state.isSubmitting ?
                    <button className="btn-primary float-right" disabled={true} onClick={() => { }}>Saving...</button> :
                    <button className="btn-primary float-right" type="submit">
                      {submitText}
                    </button>
                  }
                </div>
              </div>
            </Form>
          )
        }}
      </Formik>
      {discountModalOpen && (<DiscountModal onClose={this.closeDiscountModal}
        onSubmit={(discountValues) => { submitDiscount(discountValues, initValues, this.props, this.closeDiscountModal) }} discount={editingDiscount} />)}
    </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormDiscounts));
